module.exports = __webpack_public_path__ + "static/media/ki.84841933.svg";